import axios from 'axios';
import { getProject } from './gcloud/getProject';

export const removeSubCollection = (body, projectUrl = getProject(), httpRequest = axios) => {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  };

  return httpRequest({
    url: `${projectUrl}/deleteSubCollectionV2`,
    method: 'POST',
    headers: config,
    data: JSON.stringify(body)
  })  
}

export const removeAllFormSubCollections = ({ id, parent }, projectUrl = getProject(), httpRequest = axios) => {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${Date.now()}`
  };

  return httpRequest({
    url: `${projectUrl}/deleteAllSubCollectionsV2`,
    method: 'POST',
    headers: config,
    data: JSON.stringify({ id, parent })
  })    
}